module.exports = __webpack_public_path__ + "static/media/merchant-resources.40b670ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/merchant-resources.svg
// module id = 2324
// module chunks = 1